module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-week-039cb5df.svg";